<template>
    <el-dialog :title="'Fulfill Order'" :visible.sync="visible" width="500px" @close="close">
        <!-- <div class="formColumn f">
            <div>{{ $t('orderList.Store') }}:</div>
            <div>
                <el-input v-model="Store" disabled></el-input>
            </div>
        </div>
        <div class="formColumn f">
            <div>{{ $t('orderList.StoreOrderID') }}:</div>
            <div>
                <el-input v-model="StoreOrderID" disabled></el-input>
            </div>
        </div> -->
        <div class="formColumn f">
            <div>{{ $t('orderList.TrackingNumber') }}:</div>
            <div>
                <el-input v-model="trackingNumber" maxlength="64" show-word-limit></el-input>
            </div>
        </div>
        <div class="formColumn f">
            <div>{{ $t('orderList.ShippingCarrier') }}:</div>
            <div>
                <el-select v-model="shippingCarrier" style="width: 100%">
                    <el-option :value="item.code" :label="item.name" v-for="item in carrierSelectList" :key="item.code"></el-option>
                </el-select>
            </div>
        </div>
        <div class="formColumn f" v-if="shippingCarrier.toUpperCase() === 'OTHER'">
            <div>{{ $t('orderList.TrackingURL') }}:</div>
            <div>
                <el-input v-model="trackingUrl" maxlength="64" show-word-limit></el-input>
            </div>
        </div>
        <div slot="footer">
            <el-button @click="visible = false">{{ $t('orderList.cancelBtn')}}</el-button>
            <el-button type="primary" @click="submit">{{ $t('orderList.ok')}}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import API from '@/api'
export default {
  data() {
    return {
      title: '',
      visible: false,
      shippingCarrier: '',
      Store: '',
      StoreOrderID: '',
      trackingNumber: '',
      trackingUrl: '',
      kkOrderId: undefined
    }
  },
  computed: {
    carrierSelectList() {
      let arr = this.$store.state.common.carrierSelectList
      if (!arr.length) {
        this.$store.dispatch('common/getCarrierSelectList')
      }
      return arr
    }
  },
  methods: {
    show(item) {
      this.kkOrderId = item.kkOrderId
      this.visible = true
    },
    close() {
      ['Store', 'StoreOrderID', 'trackingNumber', 'trackingUrl'].forEach(key => {
        this[key] = undefined
      })
      this.selectValue = 1
      this.visible = false
    },
    paramsCheck() {
      const params = {
        trackingNumber: this.trackingNumber,
        kkOrderId: this.kkOrderId,
        shippingCarrier: this.shippingCarrier,
        trackingUrl: this.shippingCarrier.toUpperCase() === 'OTHER' ? this.trackingUrl : undefined
      }
      if (!this.trackingNumber) {
        this.$message.error(this.$t('promptText.msg37'))
        return false
      }
      if (!this.kkOrderId) {
        this.$message.error(this.$t('promptText.msg38'))
        return false
      }
      if (!this.shippingCarrier) {
        this.$message.error(this.$t('promptText.msg39'))
        return false
      }
      return params
    },
    submit() {
      const params = this.paramsCheck()
      if (!params) return
      API.orderRulfillment(params).then(res => {
        if (res.code === 10000) {
          this.$message.success(res.message)
          this.visible = false
          this.$emit('submitDone')
        } else {
          this.$message.error(res.message)
        }
      }).catch(err => {
        let message = err.message || err.data.message
        this.$message.error(message)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.formColumn {
    margin-bottom: 10px;
    >div {
        height: 40px;
        line-height: 40px;
    }
    >div:first-of-type {
        width: 200px;
        text-align: right;
        margin-right: 10px;
        font-weight: 600;
    }
    >div:nth-of-type(2) {
        width: 100%;
        /deep/input {
            padding-right: 50px !important;
        }
    }
}
</style>
